import { render, staticRenderFns } from "./InsightHeader.vue?vue&type=template&id=062e989c&scoped=true&"
import script from "./InsightHeader.vue?vue&type=script&lang=js&"
export * from "./InsightHeader.vue?vue&type=script&lang=js&"
import style0 from "./InsightHeader.vue?vue&type=style&index=0&id=062e989c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062e989c",
  null
  
)

export default component.exports